import { P2GLink } from '@parcel2go/core-ui';
import DropItem from './DropItem';
import { SvgMapMarker } from '@parcel2go/core-ui';
import { SvgParcel } from '@parcel2go/core-ui';
import { SvgLabelPrinting4X6 } from '@parcel2go/core-ui';
import { SvgRefresh } from '@parcel2go/core-ui';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { P2GGrid } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  viewDetails: () => void;
  viewLabels: () => void;
  viewTracking: () => void;
  arrangeReturn?: () => void;
  direction: 'row' | 'column';
}

export default function SmartSendOrderProcessOrderDrop(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  return (
    <div style={{ width: props.direction === 'row' ? '100%' : '200px' }}>
      <P2GGrid
        container
        spacing={2}
        justify={props.direction === 'row' ? 'center' : 'flex-start'}
        direction={props.direction || 'column'}
      >
        {SettingsCache.settings.Features.includes('Tracking') && (
          <DropItem icon={<SvgMapMarker />} iconSrc="/theme/icons/MapMarker.svg">
            <P2GLink onClick={props.viewTracking}>
              {t('MY_ORDERS_QUICK_ACTIONS_VIEW_TRACKING', { defaultValue: 'View Tracking' })}
            </P2GLink>
          </DropItem>
        )}
        <DropItem icon={<SvgParcel />} iconSrc="/theme/icons/Parcel.svg">
          <P2GLink onClick={props.viewDetails}>
            {t('MY_ORDERS_QUICK_ACTIONS_VIEW_DETAILS', { defaultValue: 'View Details' })}
          </P2GLink>
        </DropItem>
        <DropItem icon={<SvgLabelPrinting4X6 />} iconSrc="/theme/icons/LabelPrinting4X6.svg">
          <P2GLink onClick={props.viewLabels}>
            {t('MY_ORDERS_QUICK_ACTIONS_DOWNLOAD_LABELS', { defaultValue: 'Download Labels' })}
          </P2GLink>
        </DropItem>
        {props.arrangeReturn && (
          <DropItem icon={<SvgRefresh />} iconSrc="/theme/icons/Refresh.svg">
            <P2GLink onClick={props.arrangeReturn}>
              {t('MY_ORDERS_QUICK_ACTIONS_ARRANGE_RETURN_LABEL', { defaultValue: 'Arrange Return Label' })}
            </P2GLink>
          </DropItem>
        )}
      </P2GGrid>
    </div>
  );
}
